// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

// ** Axios Imports
import axios from "axios"

// ** UseJWT import to get config
import useJwt from "@src/auth/jwt/useJwt"

// ** Constants
import { API_AUTH_URL, API_LOGINS_URL, API_COMPANIES_URL } from "../constants"

const config = useJwt.jwtConfig

// ** Function return userData from local storage
const initialUser = () => {
  const item = window.localStorage.getItem("userData")
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {}
}

// ** Function that remove login data from BD
export const removeLoginData = () => {
  const { loginId } = initialUser()
  if (loginId) {
    axios
      .delete(`${API_LOGINS_URL}/${loginId}`)
      .then((response) => {
        if (response) console.log(`LOGIN REMOVED`)
      })
      .catch((error) => console.log(error))
  }
}

const initCompanyData = {
  storeName: '',
  storeEmail: '',
  status: '',
  coverImage: '',
  logo: '',
  type: ''
}

export const authSlice = createSlice({
  name: "authentication",
  initialState: {
    userData: initialUser(),
    recoveryData: {},
    companyData: initCompanyData,
    loadCompanyData: true
  },
  reducers: {
    setCompanyData: (state, action) => {
      state.companyData = action.payload
      state.loadCompanyData = false
    },
    handleLogin: (state, action) => {
      state.userData = action.payload
      state[config.storageTokenKeyName] =
        action.payload[config.storageTokenKeyName]
      state[config.storageRefreshTokenKeyName] =
        action.payload[config.storageRefreshTokenKeyName]
      localStorage.setItem("userData", JSON.stringify(action.payload))
      localStorage.setItem(
        config.storageTokenKeyName,
        JSON.stringify(action.payload.accessToken)
      )
      localStorage.setItem(
        config.storageRefreshTokenKeyName,
        JSON.stringify(action.payload.refreshToken)
      )
    },
    handleLogout: (state) => {
      removeLoginData()
      state.userData = {}
      state[config.storageTokenKeyName] = null
      state[config.storageRefreshTokenKeyName] = null
      // ** Remove user, accessToken & refreshToken from localStorage
      localStorage.removeItem("userData")
      localStorage.removeItem(config.storageTokenKeyName)
      localStorage.removeItem(config.storageRefreshTokenKeyName)
    }
  }
  /*extraReducers: (builder) => {
    builder.addCase(validateRecoveryToken.fulfilled, (state, action) => {
      // ** Set recoveryData in state
      state.recoveryData = action.payload.data
    })
  }*/
})

export const { handleLogin, handleLogout, setCompanyData } = authSlice.actions

export default authSlice.reducer

export const getCompanyData = () => (dispatch) => {
  const { companyActiveWeb } = initialUser()
  if (companyActiveWeb && companyActiveWeb !== undefined) {
    axios
      .get(`${API_COMPANIES_URL}/byId/${companyActiveWeb}`)
      .then((response) => {
        dispatch(setCompanyData({ ...response.data }))
      })
      .catch((error) => console.log(error))
  }
}